module.exports = __webpack_public_path__ + "img/18.e6582e43.png";